module.exports = __webpack_public_path__ + "img/outilrouge_on.fa02be3c.gif";